export default function Logo() {
	return <img src="/images/rural-logo.svg" width={ 250 } height={ 57 } alt="Rural Mutual Insurance Company" />;
}
